import { useTranslation } from "react-i18next";
import MdDarkMode from "./MdDarkMode";
import MdLightMode from "./MdLightMode";
import MdSettingsBrightness from "./MdSettingsBrightness";

export default function ThemeSelector({ theme, toggleTheme }: { theme: string | null; toggleTheme: () => void }) {
	const { t } = useTranslation();

	return (
		<div className="flex justify-between items-center flex-col xs:flex-row gap-[0.1rem] xs:gap-0 whitespace-nowrap w-full">
			<p className="m-0 leading-none">{t("navBarItems.toolsMenu.theme.title")}</p>

			<button className="flex flex-row justify-center items-center cursor-pointer" onClick={toggleTheme}>
				<span className="text-[80%] uppercase font-semibold leading-none">{t(`navBarItems.toolsMenu.theme.mode.${theme}`)}</span>&nbsp;
				{theme === "system" ? (
					<MdSettingsBrightness />
				) : theme === "light" ? (
					<MdLightMode />
				) : (
					<MdDarkMode />
				)}
			</button>
		</div>
	);
}